<p-toast [baseZIndex]="1000" position="top-right"></p-toast>
<div class="container-fluid">
  <div class="card-panel mt-5">
    <form [formGroup]="entidadeForm" autocomplete="off">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="GRUPOS DE MATERIAIS" page-subtitle="EXERCÍCIO: {{login.exercicio.ano}}"
            image-title="assets/img/stock.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/materiais']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" class="btn btn-outline-info btn-sm float-right mr-4">
            Salvar
          </button>
        </div>
      </div>
      <hr class="mt-1 mb-4" />
      <div class="project-tab">
        <div class="form-row">
          <div class="col-md-12">
            <ul class="nav nav-tabs" role="tablist" style="font-size: 13px;">
              <li class="nav-item">
                <a class="nav-link active" id="principal-tab" data-toggle="tab" href="#principal" role="tab"
                  aria-controls="principal" aria-selected="true">Dados do Grupo de Material</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" id="produto-tab" data-toggle="tab" href="#produto" role="tab"
                  aria-controls="produto" aria-selected="true">Produtos vinculado a este grupo</a>
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div class="tab-pane fade show active" id="principal" role="tabpanel" aria-labelledby="principal-tab">
                <div class="form-row pt-3">
                  <div class="col-sm-9">
                    <div class="form-row mt-2">
                      <div class="form-group col-md-3">
                        <div class="d-flex justify-content-between">
                          <label for="codigo">Código<span class="text-danger">*</span></label>
                          <span class="text-primary">#{{visualizaCodigo()}}</span>
                        </div>
                        <input #codigo_ id="codigo" formControlName="codigo" type="text" class="form-control">
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label for="nome">Nome<span class="text-danger">*</span></label>
                        <input id="nome" formControlName="nome" type="text" class="form-control font-weight-bold">
                      </div>
                    </div>
                    <div class="form-row">
                      <div class="form-group col-md-12">
                        <label for="sub_grupo">Sub-Grupo<span class="text-danger">*</span></label>
                        <p-autoComplete formControlName="sub_grupo" [field]="subGrupoAutoComplete.conversor"
                          [suggestions]="subGrupoAutoComplete.lista"
                          (completeMethod)="subGrupoAutoComplete.filtrar($event)" placeholder="Informe o nome sub-grupo"
                          inputStyleClass="form-control font-weight-bold" minLength="2" [style]="{ width: '100%' }"
                          [forceSelection]="true" [autoHighlight]="true" *ngIf="subGrupoAutoComplete"
                          (onSelect)="selectSubGrupo()">
                          <ng-template let-subGrupo pTemplate="item">
                            {{subGrupo.codigo}} {{subGrupo.nome}}
                          </ng-template>
                        </p-autoComplete>
                        <label *ngIf="entidadeForm.get('sub_grupo').value" style="color: #ef6c00"
                          class="font-weight-bold small mt-2">
                          {{ entidadeForm.get('sub_grupo').value['grupo']['nome'] }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-3">
                    <div class="card p-1">
                      <ul class="list-group list-group-flush">
                        <li class="list-group-item">
                          <div class="checkbox checbox-switch switch-success">
                            <label>
                              <input type="checkbox" formControlName="bec" disabled /><span></span>Bolsa eletrônica
                              de compra
                            </label>
                          </div>
                        </li>
                        <li class="list-group-item">
                          <div class="checkbox checbox-switch switch-warning">
                            <label>
                              <input type="checkbox" formControlName="contabilizar" /><span></span>Contabilizar
                            </label>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="tab-pane fade" id="produto" role="tabpanel" aria-labelledby="produto-tab">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <table class="table table-eddy">
                      <thead>
                        <tr>
                          <th scope="col">Código</th>
                          <th scope="col">Nome</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let item of entidade.produtos">
                          <td style="width: 20%">{{item.codigo}}</td>
                          <td style="width: 80%;">{{item.nome}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <hr class="mt-2 mb-4" />
      <div class="row">
        <div class="col-12">
          <button (click)="submitForm(true)" class="btn btn-sm btn-outline-info">
            <img src="assets/img/global/tick.png" alt="salvar" height="20" width="20">
            Salvar & novo
          </button>
        </div>
      </div>
    </form>
    <!-- <pre *ngIf="entidadeForm">{{ entidadeForm.value | json}}</pre> -->
  </div>
</div>